module.exports = "./img/5ceac9a07c2f56c6da21d04b5daff1d5.jpg";